import propTypes from 'prop-types';
import { observer } from 'mobx-react';
import { getBSLImageURL } from '../../../../utils/utils';
import { Badge } from './Badge';
import {
  CustomizationFields,
  shouldRenderCustomizationFields
} from '../../CustomizationFields';
import { PesEllipsis } from '@pes-ui/components-react';
import { createCardHtmlContent } from '../../../../helpers/helpers';

const ProductCellComponent = (props) => {
  const { card } = props;
  const badgeStyles = { background: card.productBarColor };

  return (
    <div className="my-card">
      <a className="my-card__img" href={card.href}>
        <img src={getBSLImageURL(card.imgSrc, 113)} alt={card.imgAlt} className="my-card__img-src" />
      </a>
      <div className="my-card__info">
        {card.hasStatus && (
          <Badge style={badgeStyles}>{card.productBarText}</Badge>
        )}
        {card.isSubstitute && (
          <Badge className="my-card__badge--replacing">
            {card.getReplacingBadgeTxt()}
          </Badge>
        )}
        <a className="my-card__text my-card__href" href={card.href}>
          <p className="my-card__title">{card.commRef}</p>
        </a>
          <p
            className={`my-card__desc ${
              card.elNumber ? 'my-card__desc--short' : ''
            }`}
          >
            <PesEllipsis
              maxHeight="48px"
              content={createCardHtmlContent(card.commDesc)}
            />
          </p>
        {card.elNumber && (
          <p className="my-card__el-number">
            <span className="pes-text--colon">{card.elNumberLabel}</span>
            <span>{card.elNumber}</span>
          </p>
        )}

        {shouldRenderCustomizationFields(card) && (
          <CustomizationFields
            card={card}
            shouldRenderNotification={card.isClipboardNotify}
            showClipboardNotify={card.showClipboardNotify}
            customizationId={card.customizationId}
            productCr={card.productCr}
          />
        )}
      </div>
    </div>
  );
};

ProductCellComponent.propTypes = {
  card: propTypes.shape({
    skuID: propTypes.string.isRequired,
    quantity: propTypes.oneOfType([propTypes.number, propTypes.string]),
    href: propTypes.string.isRequired,
    price: propTypes.number,
    deliveryTime: propTypes.string,
    currency: propTypes.string,
    commDesc: propTypes.string,
    imgAlt: propTypes.string,
    imgSrc: propTypes.string,
    elNumberLabel: propTypes.string,
    elNumber: propTypes.string,
    productBarColor: propTypes.string.isRequired,
    productBarText: propTypes.string.isRequired,
    getReplacingBadgeTxt: propTypes.func.isRequired,
    productCr: propTypes.string,
    customizationId: propTypes.string,
    hasStatus: propTypes.bool,
    isSubstitute: propTypes.bool,
    commRef: propTypes.string,
    isClipboardNotify: propTypes.bool,
    showClipboardNotify: propTypes.func
  }).isRequired
};

export const ProductCell = observer(ProductCellComponent);
